/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_O1_Paragraph_1Inputs */

const en_visa_o1_paragraph_1 = /** @type {(inputs: Visa_O1_Paragraph_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That means a person should not rule themselves out simply because one specific award, title, or checklist item is missing.`)
};

const pt_visa_o1_paragraph_1 = /** @type {(inputs: Visa_O1_Paragraph_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isso significa que uma pessoa não deve se descartar simplesmente porque um prêmio, cargo ou item de lista específico está faltando.`)
};

const es_visa_o1_paragraph_1 = /** @type {(inputs: Visa_O1_Paragraph_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esto significa que una persona no debe descartarse simplemente porque falte un premio, cargo o elemento de lista específico.`)
};

/**
* | output |
* | --- |
* | "That means a person should not rule themselves out simply because one specific award, title, or checklist item is missing." |
*
* @param {Visa_O1_Paragraph_1Inputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_o1_paragraph_1 = /** @type {((inputs?: Visa_O1_Paragraph_1Inputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_O1_Paragraph_1Inputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_o1_paragraph_1(inputs)
	if (locale === "es") return es_visa_o1_paragraph_1(inputs)
	return en_visa_o1_paragraph_1(inputs)
});